import { useState } from "react";
import AdminDashboard from "../DashBoard/AdminDashboard";
import AdminPropertyForm from "../DashBoard/AdminPropertyForm";
import { Menu, X } from "lucide-react";

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState("blog");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen flex bg-slate-100 relative">

      {/* MOBILE TOP BAR */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-40 bg-indigo-700 text-white flex items-center justify-between px-4 py-3">
        <h2 className="font-bold">🏢 Admin</h2>
        <button onClick={() => setSidebarOpen(true)}>
          <Menu size={26} />
        </button>
      </div>

      {/* OVERLAY (Mobile) */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-30 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* SIDEBAR */}
      <aside
        className={`
          fixed md:static top-0 left-0 z-40
          h-full w-64 bg-indigo-700 text-white p-6
          transform transition-transform duration-300
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
          md:translate-x-0
        `}
      >
        {/* Mobile Close Button */}
        <div className="flex justify-between items-center md:hidden mb-6">
          <h2 className="text-xl font-bold">🏢 Admin</h2>
          <button onClick={() => setSidebarOpen(false)}>
            <X size={24} />
          </button>
        </div>

        {/* Desktop Title */}
        <h2 className="hidden md:block text-2xl font-bold mb-10 tracking-wide">
          🏢 Real Estate Admin
        </h2>

        <button
          onClick={() => {
            setActiveTab("blog");
            setSidebarOpen(false);
          }}
          className={`w-full text-left px-4 py-3 rounded-xl mb-4 font-medium transition ${
            activeTab === "blog"
              ? "bg-indigo-900 shadow-lg"
              : "hover:bg-indigo-600"
          }`}
        >
          📝 Blog Management
        </button>

        <button
          onClick={() => {
            setActiveTab("property");
            setSidebarOpen(false);
          }}
          className={`w-full text-left px-4 py-3 rounded-xl font-medium transition ${
            activeTab === "property"
              ? "bg-indigo-900 shadow-lg"
              : "hover:bg-indigo-600"
          }`}
        >
          🏠 Property Management
        </button>
      </aside>

      {/* MAIN CONTENT */}
      <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-16 md:pt-6">
        {activeTab === "blog" && <AdminDashboard />}
        {activeTab === "property" && <AdminPropertyForm />}
      </main>
    </div>
  );
};

export default AdminPanel;
